// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__mVLKH","contentWrapper":"styles_contentWrapper__dUGqp","main":"styles_main__V7m6I"};